//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectCurve.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"GuideDirection",1,0],[1,"GuideLength",0,"Expression",0],[1,"GuideOrPartingLine",0,"SelectCurve",0],[0,"GuideVector",1,"Direction",0],[0,"SnapAngleLimit",1,0]],[[[],"DeleteSelectedGuideLine",{},0,0],[[],"DeleteAllGuideLines",{},0,0],[[],"AutoCreateGuideLines",{},0,0],[["partingLineTag","closePoint","length","created"],"CreateGuideLine",{R_:{guideLine:"Curve"}},3,0],[["directionType","guideLine"],"UpdateGuideLineDirection",{},2,0],[["guideLine"],"DeleteGuideLine",{},1,0],[["guideLine","guideLineVector","guideLinelength"],"UpdateGuideLineDirectionAndLength",{},3,0]],[]];
SPLM.Tooling.MWDesignGuideLinesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.MWDesignGuideLinesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.MWDesignGuideLinesBuilder.DirectionType = Object.freeze({
    "Normal" : "Normal", "Tangential" : "Tangential", "SnaptoWCSAxis" : "SnaptoWCSAxis", "Vector" : "Vector"});

export default SPLM;